import React from "react";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

interface AdminCardProps {
  title: string;
  description: string;
  path: string;
  icon?: React.ReactNode;
}

const AdminCard: React.FC<AdminCardProps> = ({
  title,
  description,
  path,
  icon,
}) => {
  const navigate = useNavigate();

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        width: "100%",
        minHeight: { xs: 168, sm: 184 },
        height: "100%",
        transition:
          "border-color 160ms ease, transform 160ms ease, box-shadow 160ms ease",
        "&:hover": {
          borderColor: "primary.light",
          boxShadow: "0 12px 28px rgba(233, 103, 45, 0.12) !important",
          transform: "translateY(-2px)",
        },
        "&:hover .admin-card-arrow": {
          transform: "translateX(3px)",
          color: "primary.main",
        },
        "&:hover .admin-card-icon": {
          bgcolor: "primary.main",
          color: "#fff",
        },
      }}
    >
      <CardActionArea
        onClick={() => navigate(path)}
        sx={{
          alignItems: "stretch",
          display: "flex",
          flexGrow: 1,
          height: "100%",
        }}
      >
        <CardContent sx={{ p: { xs: 2, sm: 2.5 } }}>
          <Box
            sx={{
              alignItems: "center",
              display: "flex",
              justifyContent: "space-between",
              mb: 2,
            }}
          >
            <Box
              className="admin-card-icon"
              sx={{
                alignItems: "center",
                bgcolor: "primary.lighter",
                borderRadius: 2,
                color: "primary.main",
                display: "flex",
                height: 44,
                justifyContent: "center",
                width: 44,
                transition: "background-color 160ms ease, color 160ms ease",
              }}
            >
              {icon}
            </Box>
            <ArrowForwardIcon
              className="admin-card-arrow"
              color="action"
              fontSize="small"
              sx={{ transition: "transform 160ms ease, color 160ms ease" }}
            />
          </Box>
          <Typography
            variant="h6"
            component="div"
            gutterBottom
            sx={{ fontSize: { xs: 17, sm: 20 }, fontWeight: 700 }}
          >
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default AdminCard;
